/**
* @file utils
* @author Ice(chenzhouji@baidu.com)
*/
import GithubSlugger from 'github-slugger';

type Heading = {
    value: string
    depth: number
};

const slugger = GithubSlugger();

export const loadScript = (src: string) => new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.defer = true;
    script.async = true;
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;

    head.appendChild(script);
});

export const loadStyle = (href: string) => {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');

    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = href;
    head.appendChild(link);
};

// 构造anchorId的逻辑和gatsby-remark-autolink-headers保持一致
// 具体参考 https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-remark-autolink-headers/src/index.js#L25-L29
export const createTOCItems = (headings: Heading[]): LinkItem[] => {
    slugger.reset();

    return headings.map(({value, depth}) => ({
        name: value,
        path: `#${slugger.slug(value)}`,
        depth
    }));
};
